import React, { createRef, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import MobileChatButton from "./MobileChatButton";
import RightSideContainer from "./RightSideContainer";
import useRefreshTokenSubscription from "../auth/useRefreshTokenSubscription";
import Modals from "../modals/Modals";
import Sidebar from "../sidebar/Sidebar";
import useSockets from "../sockets/useSockets";

interface Props {
  children: React.ReactNode;
}

const ContentWrapper = ({ children }: Props) => {
  const { pathname, hash } = useLocation();
  const wrapperRef = useRef(createRef<HTMLDivElement>());

  useRefreshTokenSubscription();

  // Scroll To top on path change, should only run on pathname change
  useEffect(() => wrapperRef.current?.current?.scrollTo(0, 0), [pathname]);

  useEffect(() => {
    const block = document.getElementById(hash.substring(1));
    const wrapperBoundingBlock =
      wrapperRef.current.current?.getBoundingClientRect();
    const blockBoundingBlock = block?.getBoundingClientRect();

    if (wrapperBoundingBlock && blockBoundingBlock) {
      wrapperRef.current.current?.scrollTo(
        0,
        blockBoundingBlock.top - wrapperBoundingBlock.top,
      );
    }
  }, [hash]);

  useSockets();

  return (
    <div className="outer">
      <Header />
      <div className="contentWrapper">
        <Sidebar />
        <div ref={wrapperRef.current} className="scroller">
          <div className="body">{children}</div>
          <Footer body={wrapperRef.current.current} />
        </div>
        <RightSideContainer />
        <MobileChatButton />
        <Modals />
      </div>
      <style jsx>{`
        .body {
          display: flex;
          flex-direction: column;
        }
        .outer {
          height: 100vh;
          width: 100vw;
          display: flex;
          flex-direction: column;
        }
        .scroller {
          overflow-y: auto;
          overflow-x: hidden;
          width: 100%;
        }
        .scroller::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
        .contentWrapper {
          display: flex;
          flex: 1 1 auto;
          overflow-y: hidden;
        }
      `}</style>
    </div>
  );
};

export default ContentWrapper;
